export const getStudioData = ({ studios }) => studios.studio;
export const getStudioLoading = ({ studios }) => studios.loaders.common;
export const getStudioNumberLoading = ({ studios }) => studios.loaders.number;
export const getStudioRecordsDropDown = ({ studios }) => studios.studioRecords;
export const getServiceRecordsDropDown = ({ studios }) => studios.serviceRecord;
export const getErrorStudio = ({ studios }) => studios.errors;
export const getUsersStudioDropDownSelectors = ({ studios }) =>
  studios.studioDropDown;
